import React, { useEffect, useState } from 'react';
import { Header } from 'pages/Header';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useIsMobile } from 'hooks/useIsMobile';


export function ProcesoTreminadoDesktop() {

    const { isMobile } = useIsMobile();

    return (
        <> 
            <div className={isMobile === "desktop" ? "" : "homeMobile"}>
                {isMobile === "desktop"
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />
                }
                <main className='marginTop50'>
                    <h2 className='bold'>En proceso</h2>
                </main>
            </div>
        </>
    )
}